import { Component, Input, ElementRef, AfterViewInit, ViewChild, OnInit } from '@angular/core';
import { gsap, TweenMax, Quint, Quart } from 'gsap'
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser} from '@angular/common';


class Counter {
    val: number = 0
}

@Component({
  selector: 'app-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss']
})
export class CircleComponent implements OnInit {
    isBrowser: boolean = true
    
    @ViewChild('el', { static: true })
    public el!: ElementRef;
    @ViewChild('cvsBg', { static: false })
    public cvsBg!: ElementRef;
    @ViewChild('cvs', { static: false })
    public cvs!: ElementRef;

    // @Input() public width = 400;
    // @Input() public height = 400;
    @Input() public radius = 150;
    @Input() public stroke = 1;
    @Input() public color = '#fff';
    @Input() public isloop = true;
    @Input() public set progress(val: number) {
        this.update(val);
        this._progress = val
        console.log('Input change: ' + val);
        if(val == 1) {
            // setTimeout(() => {
            //     this.animateOut()
            // }, 500);
        }
    }

    @Input() public set on(val: boolean) {
        if(val) {
            this.animateOn();
        }
        else {
            this.animateOff();
        }
    }

    private rad: number = 0
    private counter: Counter = new Counter()
    private isLooping: boolean = false
    private _progress: number = 0
    

    private ctxBg!: CanvasRenderingContext2D;
    private ctx!: CanvasRenderingContext2D;


    constructor(
        @Inject(PLATFORM_ID) private platformId: Object
    ) { 
    }
    
    ngOnInit() {
        this.isBrowser = isPlatformBrowser(this.platformId);

        this.rad = this.radius - .5 * this.stroke;
        this.counter.val = 0
        this.isLooping = (this.isloop == undefined) ? false : this.isloop;
    }


    public ngAfterViewInit() {
        // this.el.nativeElement.width = 2 * this.radius;
        // this.el.nativeElement.height = 2 * this.radius;
        if(!this.isBrowser) return;

        gsap.set(this.el?.nativeElement, {
            width: 2 * this.radius,
            height: 2 * this.radius
        });

        this.ctxBg = this.cvsBg?.nativeElement.getContext('2d');

        this.cvsBg.nativeElement.width = 2 * this.radius;
        this.cvsBg.nativeElement.height = 2 * this.radius;

        this.ctx = this.cvs.nativeElement.getContext('2d');

        this.cvs.nativeElement.width = 2 * this.radius;
        this.cvs.nativeElement.height = 2 * this.radius;
        
        setTimeout(() => {
            this.animateIn();
            if(this.isLooping) {
                this.loop();
            }
            else {
                this.update(this._progress)
            }
            // if(this._progress == 1) {
            //     setTimeout(() => {
            //         this.animateOut()
            //     }, 1000)
            // }
        },2000);

        

    }

    public animateIn() {
        let counter : Counter = new Counter()
        TweenMax.to(counter, .8, {
            val: 1,
            onUpdate: () => {
                this.ctxBg.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctxBg.globalAlpha = .2;
                this.ctxBg.strokeStyle = this.color;
                this.ctxBg.beginPath();
                this.ctxBg.arc(this.radius, this.radius, this.rad - 1, 0, (Math.PI * 2) * counter.val);
                this.ctxBg.lineWidth = this.stroke;
                this.ctxBg.stroke();
            },
            ease: Quint.easeOut
        });
    }

    animateOut() {
        if(!this.isBrowser) return;

        let counter = { val: 1 };
        TweenMax.to(counter, .8, {
            val: 0,
            onUpdate: () => {
                this.ctxBg.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctxBg.globalAlpha = .2;
                this.ctxBg.strokeStyle = this.color;
                this.ctxBg.beginPath();
                this.ctxBg.arc(this.radius, this.radius, this.rad - 1, -(Math.PI * 2) * counter.val, 0);
                this.ctxBg.lineWidth = this.stroke;
                this.ctxBg.stroke();
            },
            ease: Quint.easeOut,
        });
        if (this.counter.val > 0)
            this.animateOff();
    }

    animateOn() {
        if(!this.isBrowser) return;

        gsap.killTweensOf(this.counter);
        let value = 0;
        this.counter.val = value || 0;
        // TweenMax.to(this.counter, (1 - (value || 0)) * .8, {
        TweenMax.to(this.counter,  .8, {
            val: 1,
            onUpdate: () => {
                this.ctx.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctx.strokeStyle = this.color;
                this.ctx.beginPath();
                this.ctx.arc(this.radius, this.radius, this.rad - 1, 0, (Math.PI * 2) * this.counter.val);
                this.ctx.lineWidth = this.stroke;
                this.ctx.stroke();
            },
            ease: Quint.easeOut
        });
    }

    animateOff() {
        if(!this.isBrowser) return;

        gsap.killTweensOf(this.counter);
        let value = 0;
        this.counter.val = 1;
        TweenMax.to(this.counter, (1 - (value || 0)) * .8, {
            val: value || 0,
            onUpdate: () => {
                this.ctx.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctx.strokeStyle = this.color;
                this.ctx.beginPath();
                this.ctx.arc(this.radius, this.radius, this.rad - 1, -(Math.PI * 2) * this.counter.val, 0);
                this.ctx.lineWidth = this.stroke;
                this.ctx.stroke();
            },
            ease: Quint.easeOut
        });
    }

    loopIn() {
        gsap.killTweensOf(this.counter);
        let value = 0;
        this.counter.val = value || 0;
        TweenMax.to(this.counter, .6, {
            val: 1,
            onUpdate: () => {
                this.ctx.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctx.strokeStyle = this.color;
                this.ctx.beginPath();
                this.ctx.arc(this.radius, this.radius, this.rad - 1, 0, (Math.PI * 2) * this.counter.val);
                this.ctx.lineWidth = this.stroke;
                this.ctx.stroke();
            },
            ease: Quart.easeInOut,
            onComplete: () => {
                this.isLooping && this.loopOut();
            }
        });
    }

    loopOut() {
        if(!this.isBrowser) return;

        gsap.killTweensOf(this.counter);
        let value = 0;
        this.counter.val = 1;
        TweenMax.to(this.counter, .6, {
            val: value || 0,
            onUpdate: () => {
                this.ctx.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctx.strokeStyle = this.color;
                this.ctx.beginPath();
                this.ctx.arc(this.radius, this.radius, this.rad - 1, -(Math.PI * 2) * this.counter.val, 0);
                this.ctx.lineWidth = this.stroke;
                this.ctx.stroke();
            },
            ease: Quart.easeInOut,
            onComplete: () => {
                this.isLooping && this.loop();
            }
        });
    }

    stopLoop() {
        this.isLooping = false;
    }

    loop() {
        this.isLooping && this.loopIn();
    }

    update(value: number) {
        if(!this.isBrowser) return;
        
        value = (value == undefined) ? 0 : value
        TweenMax.to(this.counter, .4, {
            val: value,
            onUpdate: () => {
                this.ctx.clearRect(0, 0, 2 * this.radius, 2 * this.radius);
                this.ctx.strokeStyle = this.color;
                this.ctx.beginPath();
                this.ctx.arc(this.radius, this.radius, this.rad - 1, 0, (Math.PI * 2) * this.counter.val);
                this.ctx.lineWidth = this.stroke;
                this.ctx.stroke();
            },
            ease: Quint.easeOut,
        });
    }

}
